import AppConfig from "../constants/AppConfig";
import Vue from "vue";
// Vuex store
import { store } from "../store/store.js";
import router from "../router/router";
import axios from "axios";
const baseURL = AppConfig.apiUrl;

export const apiModel = {
  Auth: {
    Login: {
      method: "POST",
      // "url" : "/login"
      url: "/oauth/token",
    },
    LoginAfterRedirect: {
      method: "POST",
      // "url" : "/login"
      url: "/oauth/redirect/token",
    },
    Email: {
      method: "POST",
      // "url" : "/login"
      url: "/password/emailVersion",
    },

    SmsReset: {
      method: "POST",
      // "url" : "/login"
      url: "/password/smsVersion",
    },

    SecretReset: {
      method: "PUT",
      url: "/secretReset/:user_id",
    },

    Reset: {
      method: "POST",
      // "url" : "/login"
      url: "/password/reset",
    },

    Register: {
      method: "POST",
      url: "/register",
    },

    Logout: {
      method: "POST",
      url: "/logout",
    },

    UpdatePassword: {
      method: "POST",
      url: "/update-password",
    },
  },

  Country: {
    List: {
      method: "GET",
      url: "/countries",
    },
  },
  Message: {
    List: {
      method: "GET",
      url: "/message",
    },
    Create: {
      method: "POST",
      url: "/message",
    },
    Update: {
      method: "Put",
      url: "/message",
    },
  },
  ValidationExamen: {
    List: {
      method: "GET",
      url: "/validation/examens",
    },
    ListExamenConsultation: {
      method: "GET",
      url: "/validation/examens/consultation/:consultation",
    },
    ListExamenConsultationSouscripteur: {
      method: "GET",
      url: "/validation/examens/souscripteur",
    },
    ListValidationSouscripteur: {
      method: "GET",
      url: "/validation/souscripteur",
    },
    Notif: {
      method: "GET",
      url: "/validation/examens/count",
    },
    Create: {
      method: "POST",
      url: "/validation/examen",
    },
    Update: {
      method: "POST",
      url: "/validation/examens/etat",
    },
    Souscripteur: {
      method: "POST",
      url: "/validation/examens/souscripteur",
    },
  },
  AmaActivite: {
    // "List" : {
    //     "method" : "GET",
    //     "url" : "/referent-activites/patient/:id"
    // },
    Create: {
      method: "POST",
      url: "/activite-ama",
    },
    Save: {
      method: "POST",
      url: "/activite-ama/save",
    },
    CreateTask: {
      method: "POST",
      url: "/activite-mission-add",
    },
  },
  ReferentActivite: {
    List: {
      method: "GET",
      url: "/referent-activites/list",
    },
    createActivite: {
      method: "POST",
      url: "/referent-activites-add",
    },
    Save: {
      method: "POST",
      url: "/referent-activites/save",
    },
  },
  PecActivite: {
    CreatePec: {
      method: "POST",
      url: "/activite-pec",
    },
    ListPec: {
      method: "GET",
      url: "/activite-pec-list",
    },
  },
  Commande: {
    List: {
      method: "GET",
      url: "/commande-restante/:souscripteur",
    },
  },
  Commandes_attentes: {
    List: {
      method: "GET",
      url: "/commandes-attentes",
    },
  },
  Region: {
    List: {
      method: "GET",
      url: "/dictionnaire/regions",
    },
  },
  PartenaireList: {
    List: {
      method: "GET",
      url: "/dictionnaire/partenaire",
    },
  },
  Features: {
    List: {
      method: "GET",
      url: "/features",
    },
    Create: {
      method: "POST",
      url: "/assignFeature",
    },
  },
  Users: {
    List: {
      method: "GET",
      url: "/users",
    },
    // "One" : {
    //     "method" : "GET",
    //     "url" : "/one-user/:slug"
    // },
  },
  Role: {
    List: {
      method: "GET",
      url: "/roles",
    },
    One: {
      method: "GET",
      url: "/roles/:role",
    },
    Create: {
      method: "POST",
      url: "/assignPermission",
    },
    CreateRole: {
      method: "POST",
      url: "/role",
    },
    DeleteRole: {
      method: "DELETE",
      url: "/role/:role",
    },
  },
  Permissions: {
    List: {
      method: "GET",
      url: "/permissions",
    },
    Group: {
      method: "GET",
      url: "/permissions-group",
    },
    assignUserPermissions: {
      method: "POST",
      url: "/assignUserPermissions",
    },
  },

  Manager: {
    List: {
      method: "GET",
      url: "/gestionnaire",
    },
    Get: {
      method: "GET",
      url: "/gestionnaire/:manager",
    },
    Create: {
      method: "POST",
      url: "/gestionnaire",
    },
    Update: {
      method: "PUT",
      url: "/gestionnaire/:manager",
    },
    Delete: {
      method: "DELETE",
      url: "/gestionnaire/:manager",
    },
  },

  Patient: {
    List: {
      method: "GET",
      url: "/patient",
    },
    Get: {
      method: "GET",
      url: "/patient/:patient",
    },
    Create: {
      method: "POST",
      url: "/patient",
    },
    Update: {
      method: "PUT",
      url: "/patient/:patient",
    },
    Search: {
      method: "GET",
      url: "/patient/search/:patient",
    },
    PatientDoctor: {
      method: "GET",
      url: "/patient/doctor/:doctor",
    },
    CountPatientDoctor: {
      method: "GET",
      url: "/count_patient/doctor/:doctor",
    },
    FirstPatientDoctor: {
      method: "GET",
      url: "/patient/doctor/:doctor/:limit",
    },
    NextPatientDoctor: {
      method: "GET",
      url: "/patient/doctor/:doctor/:limit/:page",
    },
    Delete: {
      method: "DELETE",
      url: "/patient/:patient",
    },

    Decede: {
      method: "PUT",
      url: "/patient-decede/:patient",
    },
    PatientMedecin: {
      method: "GET",
      url: "/patient-with-medecin-control",
    },
    FirstPatientMedecin: {
      method: "GET",
      url: "/first_patient-with-medecin-control/:limit",
    },
    NextPatientMedecin: {
      method: "GET",
      url: "/next_patient-with-medecin-control/:limit/:page",
    },
    // "TenPatientMedecin" : {
    //     "method" : "GET",
    //     "url" : "/10patient-with-medecin-control"
    // },
    // "FifteenPatientMedecin" : {
    //     "method" : "GET",
    //     "url" : "/15patient-with-medecin-control"
    // },
    // "HundredPatientMedecin" : {
    //     "method" : "GET",
    //     "url" : "/100patient-with-medecin-control"
    // },
    CountPatientMedecin: {
      method: "GET",
      url: "/number_patient-with-medecin-control",
    },
    Institution: {
      List: {
        method: "GET",
        url: "/patient/:patient/etablissement",
      },
      Get: {
        method: "GET",
        url: "/patient/:patient/etablissement/:etablissement",
      },
      Create: {
        method: "POST",
        url: "/patient/add-etablissement",
      },
      RemovePatient: {
        method: "POST",
        url: "/etablissement/delete-patient",
      },
    },
    Subscriber: {
      Create: {
        method: "POST",
        url: "/financeur",
      },
      Delete: {
        method: "POST",
        url: "/financeur/retirer",
      },
    },
  },

  Practitioner: {
    List: {
      method: "GET",
      url: "/praticien",
    },
    Get: {
      method: "GET",
      url: "/praticien/:practitioner",
    },
    Create: {
      method: "POST",
      url: "/praticien",
    },
    Update: {
      method: "PUT",
      url: "/praticien/:practitioner",
    },
    Delete: {
      method: "DELETE",
      url: "/praticien/:practitioner",
    },
    Institution: {
      Add: {
        method: "POST",
        url: "/praticien/add-etablissement",
      },

      RemovePraticien: {
        method: "POST",
        url: "/praticien/delete-etablissement",
      },
    },
  },

  Subscriber: {
    List: {
      method: "GET",
      url: "/souscripteur",
    },
    Cim: {
      method: "GET",
      url: "/souscripteur/list/cim",
    },
    Get: {
      method: "GET",
      url: "/souscripteur/:subscriber",
    },
    Rappel: {
      method: "GET",
      url: "/souscripteur/rappel/:subscriber",
    },
    Create: {
      method: "POST",
      url: "/souscripteur",
    },
    Update: {
      method: "PUT",
      url: "/souscripteur/:subscriber",
    },
    Delete: {
      method: "DELETE",
      url: "/souscripteur/:subscriber",
    },
    Patient: {
      method: "POST",
      url: "/contrat-prepaye-store-patient",
    },
    PatientUnpaid: {
      method: "POST",
      url: "/contrat-prepaye-store-patient-unpaid",
    },
  },

  Profession: {
    List: {
      method: "GET",
      url: "/profession",
    },
    Get: {
      method: "GET",
      url: "/profession/:profession",
    },
    Create: {
      method: "POST",
      url: "/profession",
    },
    Update: {
      method: "PUT",
      url: "/profession/:profession",
    },
    Delete: {
      method: "DELETE",
      url: "/profession/:profession",
    },
  },

  Followed: {
    List: {
      method: "GET",
      url: "/suivi",
    },
    SearchList: {
      method: "GET",
      url: "/suivi/search/:suivi",
    },
    Get: {
      method: "GET",
      url: "/suivi/:suivi",
    },
    Create: {
      method: "POST",
      url: "/suivi",
    },
    Update: {
      method: "PUT",
      url: "/suivi/:suivi",
    },
    Delete: {
      method: "DELETE",
      url: "/suivi/:suivi",
    },
  },

  SpecialtyFollowed: {
    List: {
      method: "GET",
      url: "/suivi-specialite",
    },
    Get: {
      method: "GET",
      url: "/suivi-specialite/:suivi",
    },
    Create: {
      method: "POST",
      url: "/suivi-specialite",
    },
    Update: {
      method: "PUT",
      url: "/suivi-specialite/:suivi",
    },
    Delete: {
      method: "DELETE",
      url: "/suivi-specialite/:suivi",
    },
  },

  FollowedCategory: {
    List: {
      method: "GET",
      url: "/categorie",
    },
    Get: {
      method: "GET",
      url: "/categorie/:categorie",
    },
    Create: {
      method: "POST",
      url: "/categorie",
    },
    Update: {
      method: "PUT",
      url: "/categorie/:categorie",
    },
    Delete: {
      method: "DELETE",
      url: "/categorie/:categorie",
    },
  },

  TodoList: {
    List: {
      method: "GET",
      url: "/toDoList",
    },
    Get: {
      method: "GET",
      url: "/toDoList/:toDoList",
    },
    Create: {
      method: "POST",
      url: "/toDoList",
    },
    Update: {
      method: "PUT",
      url: "/toDoList/:toDoList",
    },
    Delete: {
      method: "DELETE",
      url: "/toDoList/:toDoList",
    },
  },

  MedicalAdvice: {
    List: {
      method: "GET",
      url: "/avis",
    },
    Get: {
      method: "GET",
      url: "/avis/:avis",
    },
    Create: {
      method: "POST",
      url: "/avis",
    },
    Update: {
      method: "PUT",
      url: "/avis/:avis",
    },
    Delete: {
      method: "DELETE",
      url: "/avis/:avis",
    },
    Patient: {
      method: "GET",
      url: "/avis/patient/:dossier",
    },
  },

  DoctorAdvice: {
    List: {
      method: "GET",
      url: "/avisMedecin",
    },
    Get: {
      method: "GET",
      url: "/avisMedecin/:avisMedecin",
    },
    Create: {
      method: "POST",
      url: "/avisMedecin",
    },
    Update: {
      method: "PUT",
      url: "/avisMedecin/:avisMedecin",
    },
    Delete: {
      method: "DELETE",
      url: "/avisMedecin/:avisMedecin",
    },
    EditExisting: {
      method: "POST",
      url: "/avisMedecin/:avisMedecin/nouveauAvis",
    },
  },

  AdviceResponse: {
    Get: {
      method: "GET",
      url: "/avis-repondre",
    },
  },

  Specialty: {
    List: {
      method: "GET",
      url: "/specialite",
    },
    Get: {
      method: "GET",
      url: "/specialite/:specialty",
    },
    Create: {
      method: "POST",
      url: "/specialite",
    },
    Update: {
      method: "PUT",
      url: "/specialite/:specialty",
    },
    Delete: {
      method: "DELETE",
      url: "/specialite/:specialty",
    },
  },

  CategoriePrestation: {
    List: {
      method: "GET",
      url: "/categorie-prestation",
    },
    Get: {
      method: "GET",
      url: "/categorie-prestation/:categorie_prestation",
    },
    Create: {
      method: "POST",
      url: "/categorie-prestation",
    },
    Update: {
      method: "PUT",
      url: "/categorie-prestation/:categorie_prestation",
    },
    Delete: {
      method: "DELETE",
      url: "/categorie-prestation/:categorie_prestation",
    },
  },

  Prestation: {
    List: {
      method: "GET",
      url: "/prestation",
    },
    Get: {
      method: "GET",
      url: "/prestation/:prestation",
    },
    Create: {
      method: "POST",
      url: "/prestation",
    },
    Update: {
      method: "PUT",
      url: "/prestation/:prestation",
    },
    Delete: {
      method: "DELETE",
      url: "/prestation/:prestation",
    },
  },

  Comptable: {
    List: {
      method: "GET",
      url: "/comptable",
    },
    Get: {
      method: "GET",
      url: "/comptable/:comptable",
    },
    Create: {
      method: "POST",
      url: "/comptable",
    },
    Update: {
      method: "PUT",
      url: "/comptable/:comptable",
    },
    Delete: {
      method: "DELETE",
      url: "/comptable/:comptable",
    },
  },

  EtablissementPrestation: {
    List: {
      method: "GET",
      url: "/etablissement-prestation",
    },

    Get: {
      method: "GET",
      url: "/etablissement-prestation/:prestation",
    },

    Create: {
      method: "POST",
      url: "/etablissement-prestation",
    },

    Import: {
      method: "POST",
      url: "/import_csv",
    },

    Update: {
      method: "PUT",
      url: "/etablissement-prestation/:prestation",
    },

    Delete: {
      method: "DELETE",
      url: "/etablissement-prestation/:prestation",
    },
  },
  EtablissementPrice: {
    Create: {
      method: "POST",
      url: "/examen-prix/etablissement/save",
    },
    List: {
      method: "GET",
      url: "/examen-complementaire/etablissement/:institution",
    },
    Update: {
      method: "PUT",
      url: "/examen-prix/:examen-prix",
    },
    Delete: {
      method: "DELETE",
      url: "/examen-prix/:examen-prix",
    },
  },
  Facture: {
    Print: {
      method: "GET",
      url: "/imprimer-facture-definitive/:facture",
    },

    PrintProforma: {
      method: "GET",
      url: "/imprimer-facture-proforma/:facture",
    },

    List: {
      method: "GET",
      url: "/facture",
    },
    Get: {
      method: "GET",
      url: "/facture/:facture",
    },
    Create: {
      method: "POST",
      url: "/facture",
    },

    MailRecouvrement: {
      method: "POST",
      url: "/facture-recouvrement/:facture",
    },

    MailRappel: {
      method: "POST",
      url: "/facture-rappel/:facture",
    },

    Update: {
      method: "PUT",
      url: "/facture/:facture",
    },
    Delete: {
      method: "DELETE",
      url: "/facture/:facture",
    },
  },

  FacturePrestation: {
    Create: {
      method: "POST",
      url: "/facture-prestation",
    },

    Valider: {
      method: "PUT",
      url: "/valider-prestation/:facture",
    },

    Rejeter: {
      method: "PUT",
      url: "/rejeter-prestation/:facture",
    },

    Delete: {
      method: "DELETE",
      url: "/facture-prestation/:facture",
    },
  },
  FactureAvis: {
    Print: {
      method: "GET",
      url: "/imprimer-facture-avis-definitive/:facture",
    },

    PrintProforma: {
      method: "GET",
      url: "/imprimer-facture-avis-proforma/:facture",
    },

    List: {
      method: "GET",
      url: "/facture-avis",
    },
    Get: {
      method: "GET",
      url: "/facture-avis/:facture",
    },
    Create: {
      method: "POST",
      url: "/facture-avis",
    },

    Valider: {
      method: "PUT",
      url: "/valider-avis/:facture",
    },

    Rejeter: {
      method: "PUT",
      url: "/rejeter-avis/:facture",
    },

    Delete: {
      method: "DELETE",
      url: "/facture-avis/:facture",
    },
  },
  CompteRendu: {
    Operatoire: {
      Print: {
        method: "GET",
        url: "/imprimer-compte-rendu/:compte_rendu_operatoire",
      },
      List: {
        method: "GET",
        url: "/compte-rendu-operatoire",
      },

      Create: {
        method: "POST",
        url: "/compte-rendu-operatoire",
      },

      Update: {
        method: "PUT",
        url: "/compte-rendu-operatoire/:slug",
      },

      Show: {
        method: "GET",
        url: "/compte-rendu-operatoire/:compte_rendu_operatoire",
      },

      Delete: {
        method: "DELETE",
        url: "/compte-rendu-operatoire/:compte_rendu_operatoire",
      },

      Transmit: {
        method: "PUT",
        url: "/compte-rendu-operatoire/:compte_rendu_operatoire/transmettre",
      },

      Archieve: {
        method: "PUT",
        url: "/compte-rendu-operatoire/:compte_rendu_operatoire/archiver",
      },

      Rearchieve: {
        method: "PUT",
        url: "/compte-rendu-operatoire/:compte_rendu_operatoire/reactivier",
      },
    },
  },

  ConsultationType: {
    List: {
      method: "GET",
      url: "/consultation-type",
    },
    Get: {
      method: "GET",
      url: "/consultation-type/:consultation-type",
    },
    Create: {
      method: "POST",
      url: "/consultation-type",
    },
    Update: {
      method: "PUT",
      url: "/consultation-type/:consultation-type",
    },
    Delete: {
      method: "DELETE",
      url: "/consultation-type/:consultation-type",
    },
  },

  GroupeActivite: {
    Activite: {
      Mission: {
        Update: {
          method: "PUT",
          url: "/activite-mission/:slug",
        },
        Add: {
          method: "PUT",
          url: "/activite-mission-add",
        },
        Delete: {
          method: "DELETE",
          url: "/activite-mission-delete/:slug",
        },
      },
      List: {
        method: "GET",
        url: "/activite",
      },
      Create: {
        method: "POST",
        url: "/activite",
      },
      Get: {
        method: "GET",
        url: "/activite/:activite",
      },
      Delete: {
        method: "DELETE",
        url: "/activite/:activite",
      },
      Cloturer: {
        method: "PUT",
        url: "/activite-cloture/:activite",
      },
      Update: {
        method: "PUT",
        url: "/activite/:slug",
      },
      Group: {
        method: "GET",
        url: "/show-groupe-activite/:groupe",
      },
    },
    List: {
      method: "GET",
      url: "/groupe-activite",
    },
    Get: {
      method: "GET",
      url: "/groupe-activite/:groupe_activite",
    },
    Create: {
      method: "POST",
      url: "/groupe-activite",
    },
    Update: {
      method: "PUT",
      url: "/groupe-activite/:groupe_activite",
    },
    Delete: {
      method: "DELETE",
      url: "/groupe-activite/:groupe_activite",
    },
  },

  Institution: {
    List: {
      method: "GET",
      url: "/etablissement",
    },
    Get: {
      method: "GET",
      url: "/etablissement/:institution",
    },
    GetUserInstitution: {
      method: "GET",
      url: "/user-etablissements",
    },
    Create: {
      method: "POST",
      url: "/etablissement",
    },

    Update: {
      method: "PUT",
      url: "/etablissement/:institution",
    },
    Delete: {
      method: "DELETE",
      url: "/etablissement/:institution",
    },
  },

  ControlDoctor: {
    List: {
      method: "GET",
      url: "/medecin-controle",
    },
    Get: {
      method: "GET",
      url: "/medecin-controle/:doctor",
    },
    Create: {
      method: "POST",
      url: "/medecin-controle",
    },
    Update: {
      method: "PUT",
      url: "/medecin-controle/:doctor",
    },
    Delete: {
      method: "DELETE",
      url: "/medecin-controle/:doctor",
    },
    Institution: {
      Add: {
        method: "POST",
        url: "/medecin-controle/add-etablissement",
      },

      RemoveControlDoctor: {
        method: "POST",
        url: "/medecin-controle/delete-etablissement",
      },
    },
  },

  Contract: {
    List: {
      method: "GET",
      url: "/cim",
    },
    Get: {
      method: "GET",
      url: "/cim/:contract",
    },
    Create: {
      method: "POST",
      url: "/cim",
    },
    Send: {
      method: "POST",
      url: "/cim/:contract/send",
    },
    Update: {
      method: "PUT",
      url: "/cim/:contract",
    },
    Delete: {
      method: "DELETE",
      url: "/cim/:contract",
    },
  },

  Partner: {
    List: {
      method: "GET",
      url: "/partenaire?offset=:offset&limit=:limit",
    },
    Get: {
      method: "GET",
      url: "/partenaire/:partenaire",
    },
    Create: {
      method: "POST",
      url: "/partenaire",
    },
    Update: {
      method: "PUT",
      url: "/partenaire/:partenaire",
    },
    Delete: {
      method: "DELETE",
      url: "/partenaire/:partenaire",
    },
    Roles: {
      method: "GET",
      url: "/partenaire/:partenaire/roles",
    },
  },

  Auteur: {
    Get: {
      method: "GET",
      url: "/latest-operation",
    },
  },

  RDV: {
    List: {
      method: "GET",
      url: "/rdvs?offset=:offset&limit=:limit",
    },
    Get: {
      method: "GET",
      url: "/rdvs/:rdv",
    },
    GetIntervals: {
      method: "GET",
      url: "/intervaleRdv",
    },
    Create: {
      method: "POST",
      url: "/rdvs",
    },
    Update: {
      method: "PUT",
      url: "/rdvs/:rdv",
    },
    Delete: {
      method: "DELETE",
      url: "/rdvs/:rdv",
    },
  },

  Treatment: {
    List: {
      method: "GET",
      url: "/traitement",
    },
    Get: {
      method: "GET",
      url: "/traitement/:treatment",
    },
    Create: {
      method: "POST",
      url: "/traitement",
    },
    Update: {
      method: "PUT",
      url: "/traitement/:treatment",
    },
    Delete: {
      method: "DELETE",
      url: "/traitement/:treatment",
    },
    Current: {
      List: {
        method: "GET",
        url: "/traitement-actuel",
      },
      Get: {
        method: "GET",
        url: "/traitement-actuel/:treatment",
      },
      Create: {
        method: "POST",
        url: "/traitement-actuel",
      },
      Update: {
        method: "PUT",
        url: "/traitement-actuel/:treatment",
      },
      Delete: {
        method: "DELETE",
        url: "/traitement-actuel/:treatment",
      },
    },
  },

  Allergy: {
    List: {
      method: "GET",
      url: "/allergie",
    },
    Get: {
      method: "GET",
      url: "/allergie/:allergy",
    },
    Create: {
      method: "POST",
      url: "/allergie",
    },
    Add: {
      method: "POST",
      url: "/ajouter-allergie",
    },
    AddAgain: {
      method: "POST",
      url: "/ajouter-allergie-version",
    },
    Remove: {
      method: "POST",
      url: "/retirer-allergie",
    },
    Update: {
      method: "PUT",
      url: "/allergie/:allergy",
    },
    Delete: {
      method: "DELETE",
      url: "/allergie/:allergy",
    },
  },

  Exam: {
    Physical: {
      List: {
        method: "GET",
        url: "/examen-clinique",
      },
      Get: {
        method: "GET",
        url: "/examen-clinique/:physical",
      },
      Create: {
        method: "POST",
        url: "/examen-clinique",
      },
      Update: {
        method: "PUT",
        url: "/examen-clinique/:physical",
      },
      Delete: {
        method: "DELETE",
        url: "/examen-clinique/:physical",
      },
    },

    Complementary: {
      List: {
        method: "GET",
        url: "/examen-complementaire",
      },
      Get: {
        method: "GET",
        url: "/examen-complementaire/:complementary",
      },
      Create: {
        method: "POST",
        url: "/examen-complementaire",
      },
      Update: {
        method: "PUT",
        url: "/examen-complementaire/:complementary",
      },
      Delete: {
        method: "DELETE",
        url: "/examen-complementaire/:complementary",
      },
    },
  },

  File: {
    Delete: {
      method: "DELETE",
      url: "/file/:file",
    },
  },

  Question: {
    List: {
      method: "GET",
      url: "/question",
    },
  },

  Affiliation: {
    List: {
      method: "GET",
      url: "/affiliation",
    },
    CreateAffiliationOldPatient: {
      method: "POST",
      url: "/contrat-prepaye-store-affiliation",
    },
    souscripteur: {
      method: "GET",
      url: "/affiliation/souscripteur/:id",
    },
    Get: {
      method: "GET",
      url: "/affiliationRevue/:affiliation",
    },

    Create: {
      method: "POST",
      url: "/affiliation",
    },
    Update: {
      method: "PUT",
      url: "/affiliation/:affiliation",
    },
    Status: {
      method: "POST",
      url: "/affiliation-status",
    },
    Delete: {
      method: "DELETE",
      url: "/affiliation/:affiliation",
    },
  },

  Reason: {
    List: {
      method: "GET",
      url: "/motif",
    },
    Get: {
      method: "GET",
      url: "/motif/:motif",
    },
    Create: {
      method: "POST",
      url: "/motif",
    },
    Update: {
      method: "PUT",
      url: "/motif/:motif",
    },
    Delete: {
      method: "DELETE",
      url: "/motif/:motif",
    },
  },
  Payment: {
    List: {
      method: "GET",
      url: "/payment",
    },
    ListSouscripteur: {
      method: "GET",
      url: "/paiement-prestation",
    },
    Get: {
      method: "GET",
      url: "/payment/:id",
    },
    Create: {
      method: "POST",
      url: "/payment",
    },
    Statut: {
      method: "POST",
      url: "/payment-statut/:id",
    },
    Update: {
      method: "PUT",
      url: "/payment/:payment",
    },
    Delete: {
      method: "DELETE",
      url: "/payment/:payment",
    },
    Cim: {
      method: "GET",
      url: "/get-commande-from-cim",
    },
  },
  Parameter: {
    Obstetric: {
      List: {
        method: "GET",
        url: "/parametre-obstetrique",
      },
      Get: {
        method: "GET",
        url: "/parametre-obstetrique/:parametreObstetrique",
      },
      Create: {
        method: "POST",
        url: "/parametre-obstetrique",
      },
      Update: {
        method: "PUT",
        url: "/parametre-obstetrique/:parametreObstetrique",
      },
      Delete: {
        method: "DELETE",
        url: "/parametre-obstetrique/:parametreObstetrique",
      },
    },
    Common: {
      List: {
        method: "GET",
        url: "/parametre-commun",
      },
      Get: {
        method: "GET",
        url: "/parametre-commun/:parametreCommun",
      },
      Create: {
        method: "POST",
        url: "/parametre-commun",
      },
      Update: {
        method: "PUT",
        url: "/parametre-commun/:parametreCommun",
      },
      Delete: {
        method: "DELETE",
        url: "/parametre-commun/:parametreCommun",
      },
    },
  },

  Medicament: {
    List: {
      method: "GET",
      url: "/medicament",
    },
    Get: {
      method: "GET",
      url: "/medicament/:medicament",
    },

    Rechercher: {
      method: "GET",
      url: "/medicament/search/",
    },

    Create: {
      method: "POST",
      url: "/medicament",
    },
    Update: {
      method: "PUT",
      url: "/medicament/:medicament",
    },
    Delete: {
      method: "DELETE",
      url: "/medicament/:medicament",
    },
  },

  Ordonance: {
    List: {
      method: "GET",
      url: "/ordonance",
    },
    Get: {
      method: "GET",
      url: "/ordonance/:ordonance",
    },
    Create: {
      method: "POST",
      url: "/ordonance",
    },
    Update: {
      method: "PUT",
      url: "/ordonance/:ordonance",
    },
    Delete: {
      method: "DELETE",
      url: "/ordonance/:ordonance",
    },

    Archieve: {
      method: "PUT",
      url: "/ordonance/:ordonance/archiver",
    },

    Transmit: {
      method: "PUT",
      url: "/ordonance/:ordonance/transmettre",
    },
  },

  Consultation: {
    Cardiology: {
      List: {
        method: "GET",
        url: "/consultation-cardiologie",
      },
      Get: {
        method: "GET",
        url: "/consultation-cardiologie/:consultation",
      },
      Create: {
        method: "POST",
        url: "/consultation-cardiologie",
      },
      Update: {
        method: "PUT",
        url: "/consultation-cardiologie/:consultation",
      },
      Delete: {
        method: "DELETE",
        url: "/consultation-cardiologie/:consultation",
      },

      Archieve: {
        method: "PUT",
        url: "/consultation-cardiologie/:consultation/archiver",
      },

      Transmit: {
        method: "PUT",
        url: "/consultation-cardiologie/:consultation/transmettre",
      },

      Reactive: {
        method: "PUT",
        url: "/consultation-cardiologie/:consultation/reactiver",
      },

      Print: {
        method: "GET",
        url: "/imprimer-consultation-cardiologie/:cardiologie",
      },
    },

    Manuscrit: {
      List: {
        method: "GET",
        url: "/consultation-fichier",
      },
      Get: {
        method: "GET",
        url: "/consultation-fichier/:consultation",
      },
      Create: {
        method: "POST",
        url: "/consultation-fichier",
      },
      Update: {
        method: "PUT",
        url: "/consultation-fichier/:consultation",
      },
      Delete: {
        method: "DELETE",
        url: "/consultation-fichier/:consultation",
      },

      Archieve: {
        method: "PUT",
        url: "/consultation-fichier/:consultation/archiver",
      },

      Transmit: {
        method: "PUT",
        url: "/consultation-fichier/:consultation/transmettre",
      },

      Reactive: {
        method: "PUT",
        url: "/consultation-fichier/:consultation/reactiver",
      },
    },

    Obstetric: {
      List: {
        method: "GET",
        url: "/consultation-obstetrique",
      },
      Get: {
        method: "GET",
        url: "/consultation-obstetrique/:consultation",
      },
      Create: {
        method: "POST",
        url: "/consultation-obstetrique",
      },
      Update: {
        method: "PUT",
        url: "/consultation-obstetrique/:consultation",
      },
      Delete: {
        method: "DELETE",
        url: "/consultation-obstetrique/:consultation",
      },

      Archieve: {
        method: "PUT",
        url: "/consultation-obstetrique/:consultation/archiver",
      },

      Transmit: {
        method: "PUT",
        url: "/consultation-obstetrique/:consultation/transmettre",
      },

      Reactive: {
        method: "PUT",
        url: "/consultation-obstetrique/:consultation/reactiver",
      },
    },

    Prenatal: {
      List: {
        method: "GET",
        url: "/consultation-prenatale",
      },
      Get: {
        method: "GET",
        url: "/consultation-prenatale/:consultation",
      },
      Create: {
        method: "POST",
        url: "/consultation-prenatale",
      },
      Update: {
        method: "PUT",
        url: "/consultation-prenatale/:consultation",
      },
      Delete: {
        method: "DELETE",
        url: "/consultation-prenatale/:consultation",
      },
      Archieve: {
        method: "PUT",
        url: "/consultation-prenatale/:consultation/archiver",
      },
      Transmit: {
        method: "PUT",
        url: "/consultation-prenatale/:consultation/transmettre",
      },
      AddPhysicalExams: {
        method: "POST",
        url: "/consultation-prenantale/ajouter-examen-clinique",
      },
      RemovePhysicalExams: {
        method: "POST",
        url: "/consultation-prenantale/retirer-examen-clinique",
      },
      AddComplementaryExams: {
        method: "POST",
        url: "/consultation-prenantale/ajouter-examen-complementaire",
      },
      RemoveComplementaryExams: {
        method: "POST",
        url: "/consultation-prenantale/retirer-examen-complementaire",
      },
    },

    General: {
      Print: {
        method: "GET",
        url: "/imprimer-consultation-medecine/:generale",
      },

      List: {
        method: "GET",
        url: "/consultation-medecine",
      },
      Get: {
        method: "GET",
        url: "/consultation-medecine/:consultation",
      },
      Create: {
        method: "POST",
        url: "/consultation-medecine",
      },
      Update: {
        method: "PUT",
        url: "/consultation-medecine/:consultation",
      },
      Delete: {
        method: "DELETE",
        url: "/consultation-medecine/:consultation",
      },
      PhysicalExam: {
        Create: {
          method: "POST",
          url: "/consultation/ajouter-examen-clinique",
        },
        Delete: {
          method: "DELETE",
          url: "/consultation/retirer-examen-clinique",
        },
      },
      ComplementaryExam: {
        Create: {
          method: "POST",
          url: "/consultation/ajouter-examen-complementaire",
        },
        Delete: {
          method: "DELETE",
          url: "/consultation/retirer-examen-complementaire",
        },
      },
      Reason: {
        Create: {
          method: "POST",
          url: "/consultation-medecine-motif/ajouter-motif",
        },
        Delete: {
          method: "POST",
          url: "/consultation-medecine-motif/retirer-motif",
        },
      },

      Archieve: {
        method: "PUT",
        url: "/consultation-medecine/:consultation/archiver",
      },

      Transmit: {
        method: "PUT",
        url: "/consultation-medecine/:consultation/transmettre",
      },

      Reactive: {
        method: "PUT",
        url: "/consultation-medecine/:consultation/reactiver",
      },
    },

    Kinesitherapie: {
      Print: {
        method: "GET",
        url: "/imprimer-rapport-kinesitherapie/:kinesitherapie",
      },
      List: {
        method: "GET",
        url: "/consultation-kinesitherapie",
      },

      Create: {
        method: "POST",
        url: "/consultation-kinesitherapie",
      },

      Update: {
        method: "PUT",
        url: "/consultation-kinesitherapie/:slug",
      },

      Show: {
        method: "GET",
        url: "/consultation-kinesitherapie/:consultation",
      },

      Delete: {
        method: "DELETE",
        url: "/consultation-kinesitherapie/:consultation",
      },

      Transmit: {
        method: "PUT",
        url: "/consultation-kinesitherapie/:consultation/transmettre",
      },

      Archieve: {
        method: "PUT",
        url: "/consultation-kinesitherapie/:consultation/archiver",
      },

      Rearchieve: {
        method: "PUT",
        url: "/consultation-kinesitherapie/:consultation/reactivier",
      },
      Reactive: {
        method: "PUT",
        url: "/consultation-kinesitherapie/:consultation/reactiver",
      },
    },
  },

  Examen: {
    Cardio: {
      List: {
        method: "GET",
        url: "/examen-cardiologie",
      },

      Get: {
        method: "GET",
        url: "/examen-cardiologie/:examen",
      },

      Create: {
        method: "POST",
        url: "/examen-cardiologie",
      },

      Update: {
        method: "PUT",
        url: "/examen-cardiologie/:examen",
      },

      Delete: {
        method: "DELETE",
        url: "/examen-cardiologie/:examen",
      },
    },
  },

  Ultrasound: {
    List: {
      method: "GET",
      url: "/echographie",
    },
    Get: {
      method: "GET",
      url: "/echographie/:ultrasound",
    },
    Create: {
      method: "POST",
      url: "/echographie",
    },
    Update: {
      method: "PUT",
      url: "/echographie/:ultrasound",
    },
    Delete: {
      method: "DELETE",
      url: "/echographie/:ultrasound",
    },
  },

  MedicalFile: {
    Print: {
      method: "GET",
      url: "/imprimer-dossier/:dossier",
    },
    List: {
      method: "GET",
      url: "/dossier",
    },
    MedecinPatient: {
      method: "POST",
      url: "/medecin-patient",
    },
    DeleteMedecinPatient: {
      method: "DELETE",
      url: "/medecin-patient/:slug",
    },
    Get: {
      method: "GET",
      url: "/dossier/:file",
    },
    My: {
      method: "GET",
      url: "/dossiers-mes-patient",
    },
    MySearch: {
      method: "GET",
      url: "/dossiers-mes-patient/search/:patient",
    },
    Create: {
      method: "POST",
      url: "/dossier",
    },
    Update: {
      method: "PUT",
      url: "/dossier/:file",
    },
    Delete: {
      method: "DELETE",
      url: "/dossier/:file",
    },
    Patient: {
      Get: {
        method: "GET",
        url: "/:patient/dossier-medical",
      },
    },
  },

  Hospitalisation: {
    Print: {
      method: "GET",
      url: "/imprimer-rapport-hospitalisation/:hospitalisation",
    },
    List: {
      method: "GET",
      url: "/hospitalisation",
    },
    Get: {
      method: "GET",
      url: "/hospitalisation/:hospitalisation",
    },
    Create: {
      method: "POST",
      url: "/hospitalisation",
    },
    Update: {
      method: "PUT",
      url: "/hospitalisation/:hospitalisation",
    },
    Delete: {
      method: "DELETE",
      url: "/hospitalisation/:hospitalisation",
    },
    PhysicalExam: {
      Create: {
        method: "POST",
        url: "/hospitalisation/ajouter-examen-clinique",
      },
      Delete: {
        method: "DELETE",
        url: "/hospitalisation/retirer-examen-clinique",
      },
    },
    ComplementaryExam: {
      Create: {
        method: "POST",
        url: "/hospitalisation/ajouter-examen-complementaire",
      },
      Delete: {
        method: "DELETE",
        url: "/hospitalisation/retirer-examen-complementaire",
      },
    },
    Reason: {
      Create: {
        method: "POST",
        url: "/hospitalisation/ajouter-motif",
      },
      Delete: {
        method: "POST",
        url: "/hospitalisation/retirer-motif",
      },
    },
    Archieve: {
      method: "PUT",
      url: "/hospitalisation/:hospitalisation/archiver",
    },

    Transmit: {
      method: "PUT",
      url: "/hospitalisation/:hospitalisation/transmettre",
    },
  },

  Antecedent: {
    List: {
      method: "GET",
      url: "/antecedent",
    },
    Get: {
      method: "GET",
      url: "/antecedent/:antecedent",
    },
    Create: {
      method: "POST",
      url: "/antecedent",
    },
    Update: {
      method: "PUT",
      url: "/antecedent/:antecedent",
    },
    Delete: {
      method: "DELETE",
      url: "/antecedent/:antecedent",
    },
  },

  Conclusion: {
    List: {
      method: "GET",
      url: "/conclusion",
    },
    Get: {
      method: "GET",
      url: "/conclusion/:conclusion",
    },
    Create: {
      method: "POST",
      url: "/conclusion",
    },
    Update: {
      method: "PUT",
      url: "/conclusion/:conclusion",
    },
    Delete: {
      method: "DELETE",
      url: "/conclusion/:conclusion",
    },
  },

  PaiementMethod: {
    MomoPaid: {
      method: "POST",
      url: "/momo/paid/:identifiant/",
    },

    MomoStatut: {
      method: "POST",
      url: "/momo/statutPaiement",
    },

    OmPaid: {
      method: "POST",
      url: "/om/paid/:identifiant",
    },

    OmPaidStatut: {
      method: "GET",
      url: "/om/:identifiant/:payToken/statutPaiement",
    },

    UpdateStatus: {
      method: "PUT",
      url: "/contratVisiteur/:identifiant/status",
    },

    Delete: {
      method: "DELETE",
      url: "/contratVisiteur/:identifiant",
    },
    Send: {
      method: "POST",
      url: "/contratVisiteur/:identifiant/send",
    },
    SendPassword: {
      method: "POST",
      url: "/contratVisiteur/send-password",
    },
  },

  Result: {
    Lab: {
      List: {
        method: "GET",
        url: "/resultat-labo",
      },
      Get: {
        method: "GET",
        url: "/resultat-labo/:result",
      },
      Create: {
        method: "POST",
        url: "/resultat-labo",
      },
      Update: {
        method: "PUT",
        url: "/resultat-labo/:result",
      },
      Delete: {
        method: "DELETE",
        url: "/resultat-labo/:result",
      },

      Archieve: {
        method: "PUT",
        url: "/resultat-labo/:resultat/archiver",
      },

      Transmit: {
        method: "PUT",
        url: "/resultat-labo/:resultat/transmettre",
      },
    },
    Imagery: {
      List: {
        method: "GET",
        url: "/resultat-imagerie",
      },
      Get: {
        method: "GET",
        url: "/resultat-imagerie/:result",
      },
      Create: {
        method: "POST",
        url: "/resultat-imagerie",
      },
      Update: {
        method: "PUT",
        url: "/resultat-imagerie/:result",
      },
      Delete: {
        method: "DELETE",
        url: "/resultat-imagerie/:result",
      },

      Archieve: {
        method: "PUT",
        url: "/resultat-imagerie/:resultat/archiver",
      },

      Transmit: {
        method: "PUT",
        url: "/resultat-imagerie/:resultat/transmettre",
      },
    },
  },
  Association: {
    List: {
      method: "GET",
      url: "/association",
    },
    Get: {
      method: "GET",
      url: "/association/:association",
    },
    Create: {
      method: "POST",
      url: "/association",
    },
    Update: {
      method: "PUT",
      url: "/association/:association",
    },
    Delete: {
      method: "DELETE",
      url: "/association/:association",
    },
  },
  Assistante: {
    List: {
      method: "GET",
      url: "/assistante",
    },
    Get: {
      method: "GET",
      url: "/assistante/:assistante",
    },
    Create: {
      method: "POST",
      url: "/assistante",
    },
    Update: {
      method: "PUT",
      url: "/assistante/:assistante",
    },
    Delete: {
      method: "DELETE",
      url: "/assistante/:assistante",
    },
  },
  Timeline: {
    // "List" : {
    //     "method" : "GET",
    //     "url" : "/ligne-temps/dossier/{id}"
    // },
    List: {
      method: "GET",
      url: "/ligne-temps/dossier/:file",
    },

    patient: {
      method: "GET",
      url: "/ligne-temps/dossier/:file",
    },
    Trajet: {
      method: "GET",
      url: "/trajet-patient/dossier/:file",
    },
    Get: {
      method: "GET",
      url: "/ligne-temps/dossier/:ligne-temps",
    },
    Create: {
      method: "POST",
      url: "/ligne-temps",
    },
    Update: {
      method: "PUT",
      url: "/ligne-temps/:ligne-temps",
    },
    Delete: {
      method: "DELETE",
      url: "/ligne-temps/:ligne-temps",
    },
  },

  Alertes: {
    List: {
      method: "GET",
      url: "/v2/alertes",
    },
    Get: {
      method: "GET",
      url: "/v2/alertes/",
    },
    Create: {
      method: "POST",
      url: "/v2/alertes",
    },
    Update: {
      method: "PUT",
      url: "/v2/alertes/{alerte}",
    },
    UpdateAlerte: {
      method: "PATCH",
      url: "/v2/alertes/:alertes",
    },
    Delete: {
      method: "DELETE",
      url: "/v2/alertes/:alertes",
    },
    NiveauUrgence: {
      method: "GET",
      url: "/v2/niveau_urgences",
    },
    SearchPatient: {
      method: "GET",
      url: "/v2/patients?search:patient",
    },
  },
  groupes: {
    index: {
      method: "GET",
      url: "/v2/groupes",
    },
    show: {
      method: "GET",
      url: "/v2/groupes/:groupe",
    },
    store: {
      method: "POST",
      url: "/v2/groupes",
    },
    update: {
      method: "PATCH",
      url: "/v2/groupes/:groupe",
    },
    delete: {
      method: "DELETE",
      url: "/v2/groupes/:groupe",
    },
    searchPatient: {
      method: "GET",
      url: "/v2/patients-et-souscripteurs?search=:patient",
    },
  },
  Medecins: {
    List: {
      method: "GET",
      url: "/v2/medecins",
    },
    Get: {
      method: "GET",
      url: "/v2/medecins/",
    },
    Create: {
      method: "POST",
      url: "/v2/medecins",
    },
    Update: {
      method: "PUT",
      url: "/v2/medecins/:medecins",
    },
    Delete: {
      method: "DELETE",
      url: "/v2/medecins/:medecins",
    },
  },
  Notifications: {
    List: {
      method: "GET",
      url: "/v2/notifications",
    },
    Get: {
      method: "GET",
      url: "/v2/notifications/",
    },
    Create: {
      method: "POST",
      url: "/v2/notifications",
    },
    Update: {
      method: "PUT",
      url: "/v2/notifications/:notifications",
    },
    Delete: {
      method: "DELETE",
      url: "/v2/medecins/:medecins",
    },
  },
  // Mobile
  Prestataire: {
    List: {
      method: "GET",
      url: "/v3/prestataires",
    },
  },

  Etablissement: {
    List: {
      method: "GET",
      url: "/v3/etablissements/all",
    },
  },
  Metriques: {
    List: {
      method: "GET",
      url: "/v3/metrique",
    },
  },

  // "EtablissementPrice" : {
  //     "Create" : {
  //         "method" : "POST",
  //         "url" : "/examen-prix"
  //     },
  //     "Update" : {
  //         "method" : "PUT",
  //         "url" : "/examen-prix/:examen-prix"
  //     },
  //     "Delete" : {
  //         "method" : "DELETE",
  //         "url" : "/examen-prix/:examen-prix"
  //     }
  // },
};

export async function makeApiRequest(
  args,
  object,
  token = "",
  successCallback = {},
  errorCallback = {},
  errorMessages = {},
  hasFile = false
) {
  let method = object.method;
  let urlSuffix = object.url;
  let finalUrlSuffix = "";

  // Adjust API url
  if (Object.keys(args).length === 0 && args.constructor === Object) {
    finalUrlSuffix = urlSuffix;
  } else {
    Object.keys(args).forEach(function (key) {
      finalUrlSuffix = urlSuffix.replace(`:${key}`, args[key]);
      urlSuffix = finalUrlSuffix;
    });
  }

  // Set headers
  let customHeaders = {};
  customHeaders["headers"] = {};

  // Set token in request header if necessary
  if (token != "") {
    customHeaders["headers"]["Authorization"] = "Bearer " + token;
  }

  // Set request content type
  if (hasFile) {
    customHeaders["headers"]["Content-Type"] = "multipart/form-data";
  }

  axios.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      if (
        !config.url.includes("api/medicament/search") &&
        !/api\/suivi\/*[a-zA-Z]*/.test(config.url)
      ) {
        store.dispatch("setLoading", { loading: true });
      }

      return config;
    },
    function (error) {
      // Do something with request error
      store.dispatch("setLoading", { loading: false });
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      store.dispatch("setLoading", { loading: false });
      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      store.dispatch("setLoading", { loading: false });
      return Promise.reject(error);
    }
  );

  let response;
  let self = this;

  switch (method) {
    case "POST":
      try {
        response = await Vue.axios
          .post(baseURL + finalUrlSuffix.trim(), args, customHeaders)
          .then(successCallback)
          .catch((error) => {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              store.dispatch("record", { errors: error.response.data.error });
              if (error.response.data.hasOwnProperty("message")) {
                if (
                  error.response.data.message == "Unauthenticated." ||
                  error.response.data.message == "vous devez vous authentifier"
                ) {
                  localStorage.clear();
                  router.push({ name: "login" });
                }
              }

              Vue.swal({
                type: "error",
                title: error.response.data.message,
              });
            } else if (error.request) {
              // The request was made but no response was received
              // 'error.request' is an isntance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log("Request error", error.request);

              Vue.swal({
                type: "error",
                title: self.errorMessages.generic,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              if (!_.isUndefined(error.message)) {
                if (error.message == "vous devez vous authentifier") {
                  localStorage.clear();
                  router.push({ name: "login" });
                }

                Vue.swal({
                  type: "error",
                  title: error.message,
                });
              }
              localStorage.clear();
              router.push({ name: "login" });
              console.log("Config error:", error.config);
            }
          });
      } catch (error) {
        console.log("Error:", error);
        store.dispatch("record", { errors: error.response.data.error });
        Vue.swal({
          type: "error",
          title: self.errorMessages.generic,
        });
      }

      break;

    case "GET":
      try {
        response = await Vue.axios
          .get(baseURL + finalUrlSuffix.trim(), {
            params: args,
            headers: customHeaders["headers"],
          })
          .then(successCallback)
          .catch((error) => {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              store.dispatch("record", { errors: error.response.data.error });
              if (error.response.data.hasOwnProperty("message")) {
                if (
                  error.response.data.message == "Unauthenticated." ||
                  error.response.data.message == "vous devez vous authentifier"
                ) {
                  // console.log("Data :", error.response.data);
                  // console.log("Status:", error.response.status);
                  // console.log("Headers:", error.response.headers);
                  // console.log("error.response.data.message:", error.response.data.message);
                  localStorage.clear();
                  router.push({ name: "login" });
                }
              } else if (
                error.response.data.error == "Unauthenticated." ||
                error.response.data.error == "vous devez vous authentifier"
              ) {
                localStorage.clear();
                router.push({ name: "login" });
              }
              Vue.swal({
                type: "error",
                title: error.response.data.message,
              });
            } else if (error.request) {
              // The request was made but no response was received
              // 'error.request' is an isntance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log("Request error", error.request);

              Vue.swal({
                type: "error",
                title: self.errorMessages.generic,
              });
            } else if (error.message == "vous devez vous authentifier") {
              localStorage.clear();
              router.push({ name: "login" });
              Vue.swal({
                type: "error",
                title: error.message,
              });
            } else {
              // Something happened in setting up the request that triggered an Error

              Vue.swal({
                type: "error",
                title: error.message,
              });
            }

            localStorage.clear();
            router.push({ name: "login" });
            console.log("Config error:", error.config);
          });
      } catch (error) {
        Vue.swal({
          type: "error",
          title: errorMessages.generic,
        });
      }

      break;

    case "PUT":
      try {
        response = await Vue.axios
          .put(baseURL + finalUrlSuffix.trim(), args, customHeaders)
          .then(successCallback)
          .catch((error) => {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              // console.log("Data:", error.response.data);
              // console.log("Status:", error.response.status);
              // console.log("Headers:", error.response.headers);
              store.dispatch("record", { errors: error.response.data.error });
              if (error.response.data.hasOwnProperty("message")) {
                if (
                  error.response.data.message == "Unauthenticated." ||
                  error.response.data.message == "vous devez vous authentifier"
                ) {
                  localStorage.clear();
                  router.push({ name: "login" });
                }
              } else if (
                error.response.data.error == "Unauthenticated." ||
                error.response.data.error == "vous devez vous authentifier"
              ) {
                localStorage.clear();
                router.push({ name: "login" });
              }
              Vue.swal({
                type: "error",
                title: error.response.data.message,
              });
            } else if (error.request) {
              // The request was made but no response was received
              // 'error.request' is an isntance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log("Request error", error.request);

              Vue.swal({
                type: "error",
                title: self.errorMessages.generic,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              if (error.message == "vous devez vous authentifier") {
                localStorage.clear();
                router.push({ name: "login" });
              }

              Vue.swal({
                type: "error",
                title: error.message,
              });
            }

            localStorage.clear();
            router.push({ name: "login" });
            console.log("Config error:", error.config);
          });
      } catch (error) {
        Vue.swal({
          type: "error",
          title: errorMessages.generic,
        });
      }

      break;

    case "DELETE":
      try {
        response = await Vue.axios
          .delete(baseURL + finalUrlSuffix.trim(), customHeaders)
          .then(successCallback)
          .catch((error) => {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              // console.log("Data:", error.response.data);
              // console.log("Status:", error.response.status);
              // console.log("Headers:", error.response.headers);
              store.dispatch("record", { errors: error.response.data.error });
              if (error.response.data.hasOwnProperty("message")) {
                if (
                  error.response.data.message == "Unauthenticated." ||
                  error.response.data.message == "vous devez vous authentifier"
                ) {
                  localStorage.clear();
                  router.push({ name: "login" });
                }
              }
              Vue.swal({
                type: "error",
                title: error.response.data.message,
              });
            } else if (error.request) {
              // The request was made but no response was received
              // 'error.request' is an isntance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log("Request error", error.request);

              Vue.swal({
                type: "error",
                title: self.errorMessages.generic,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              if (error.message == "vous devez vous authentifier") {
                localStorage.clear();
                router.push({ name: "login" });
              }

              Vue.swal({
                type: "error",
                title: error.message,
              });
            }

            localStorage.clear();
            router.push({ name: "login" });
            console.log("Config error:", error.config);
          });
      } catch (error) {
        Vue.swal({
          type: "error",
          title: self.errorMessages.generic,
        });
      }

      break;
  }
}
